<script setup lang="ts">
import {useUserStore} from '~/stores/user'

const route = useRoute()
const userStore = useUserStore()
</script>
<template>
  <AtomsIconButton v-if="userStore.isTeacher"
                   :to="localePath('me-collections')"
                   v-tooltip="$t('favorite_directory.my_directories')"
                   icon="folder_special"
                   :active="route.path === localePath('me-collections')"
                   :with-notification-pill="userStore.hasUnseenCaptures"/>
</template>